import { render, staticRenderFns } from "./PerformSearchBox.vue?vue&type=template&id=747d45e7&"
import script from "./PerformSearchBox.vue?vue&type=script&lang=js&"
export * from "./PerformSearchBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports